import React from "react";
import { useSelector } from "react-redux";
import RevenueTable from "./revenueTable";

export default function RevenueTableHeader() {
  const allRevenue = useSelector((state) => state.multiLocation.allRevenue);

  const { membership_revenue_mom_total, revenue_mom_total } = allRevenue;
  let membershipMoMTotalClass, revenueMoMTotalClass;

  if (membership_revenue_mom_total && membership_revenue_mom_total.indexOf("-") > -1) {
    membershipMoMTotalClass = "negative";
  } else {
    membershipMoMTotalClass = "positive";
  }

  if (revenue_mom_total && revenue_mom_total.indexOf("-") > -1) {
    revenueMoMTotalClass = "negative";
  } else {
    revenueMoMTotalClass = "positive";
  }

  return (
    <section className="section-table">
      <div className="table-wrapper-top">
        <div className="table-top total-revenue">
          <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
            <div className="title">
              <h2>{allRevenue.titles[0]}</h2>
            </div>
            <div className="metrics" style={{ width: "45%" }}>
              <p>{allRevenue.titles[1]}</p>
              <div className="sub-metrics">
                <p className="total">
                  <span>
                    <span>{allRevenue.revenue_total}</span>
                    {allRevenue.revenue_mom_total !== "0.0%" ? (
                      <span className={`percent ${revenueMoMTotalClass}`}>
                        {allRevenue.revenue_mom_total}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Previous: <span>{allRevenue.revenue_lm_total}</span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Average: <span>{allRevenue.revenue_total_average}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="table-top membership-revenue">
          <div className="table-top-wrapper" style={{ minHeight: "91px" }}>
            <div className="title">
              <h2>{allRevenue.titles[2]}</h2>
              <p>&nbsp;</p>
            </div>
            <div className="metrics" style={{ width: "45%" }}>
              <p>{allRevenue.titles[3]}</p>
              <div className="sub-metrics">
                <p className="total">
                  <span>
                    <span>{allRevenue.membership_revenue_total}</span>
                    {allRevenue.membership_revenue_mom_total !== "0.0%" ? (
                      <span className={`percent ${membershipMoMTotalClass}`}>
                        {allRevenue.membership_revenue_mom_total}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Previous:&nbsp;
                  <span>{allRevenue.membership_revenue_lm_total}</span>
                </p>
              </div>
              <div className="sub-metrics">
                <p>
                  Average:&nbsp;
                  <span>{allRevenue.membership_revenue_total_average}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table-wrapper revenue-table">
        <RevenueTable />
      </div>
    </section>
  );
}
